<div [@isExpanded]="isCreateMenuExpanded"
     class="ui-action-expander-container">
  <ng-container *ngIf="isCreateMenuExpanded"
                [ngTemplateOutlet]="buttons">
  </ng-container>
</div>
<button [disabled]="disabled"
        [matTooltip]="isCreateMenuExpanded ? tooltipClose : tooltipOpen"
        (uiClickOutside)="isCreateMenuExpanded = false"
        (click)="isCreateMenuExpanded = !isCreateMenuExpanded"
        mat-mini-fab
        color="primary"
        type="button"
        class="ui-action-expander-trigger">
  <mat-icon [@isOpen]="isCreateMenuExpanded ? 'closed' : 'open'">add</mat-icon>
</button>

<!--
    there's a problem with the animations API, it doesn't work correctly with projected content
    so we wrap it inside an <ng-template>
 -->
<ng-template #buttons>
  <ng-content></ng-content>
</ng-template>
